/**
 * To create Select.
 */

(function($, window, document, undefined) {
    /**
    * @param {string} elem - current element.
    * @param {string} options - Options pass to plugin by user.
    */

    var createWrapper = function(){
        var elem = this.$elem;
        //var width = elem.outerWidth();
        var cssDisplay = elem.css('display');
        var cssFloat = elem.css('float');

        var wrapper = $('<div>', {
            id: this.overlayId,
            class: 'ez-select-wrap' + this.options.cssClasses,
            css: {
                //width: width,
                display: cssDisplay,
                float: cssFloat
            }
        });

        elem.wrap(wrapper);
        this.$overlay = $('#'+ this.overlayId);

    };

    var getOptions = function(elem){
        var options = elem.find('option');
        var value = elem.val();
        var index = 0;

        var values = $.map(options ,function(option) {
            return {
                value: option.value,
                label: option.label || option.text,
                selected: option.selected,
                disabled: option.disabled,
                index: option.disabled ?  '' : index++,
                glue: $(option).data('glue')
            };
        });

        return values;

    };

    var createOptionList = function(){
        var arr = getOptions(this.$elem);
        var search = this.options.search;
        var context = {
            optionWrapper: this.optionWrapperId,
            searchId: search ? this.searchId : null,
            searchInputId: search ? this.searchInputId : null,
            options: arr
        };

        $('body').append(this.template(context));
        this.$optionWrapper = $('#'+ this.optionWrapperId);

        if(search) {
            $('#'+this.searchInputId).filterSearch({
                container: '#'+ this.searchId,
                items: '> li:not([data-glue])'
            });
        }
    };

    var attachEvent = function(){
        var options = this.options;

        $('#'+this.overlayId).on(options.trigger + '.' + this.type, $.proxy(this.show, this));
        this.$elem.on('focus' + '.' + this.type, $.proxy(this.show, this));
    };

    var addSelected = function(elem){
        var classes = this.options.selectedClass;
        elem.addClass(classes).siblings().removeClass(classes);
    };

    var setValue = function(elem){
        if (!this.active) {
            return;
        }
        this.active = false;

        if(!elem) {
           elem = $('#' + this.searchId).find('.'+ this.options.selectedClass);
        } else {
            addSelected.call(this, elem);
        }

        var selectVal = this.$elem.val();
        var value = elem.data('value');

        if (selectVal !== value) {
            this.$elem.val(value).change();
        }

    };

    var getFirstNode = function(wrapper){
        return wrapper.find('[data-value]:visible:first');
    };

    var getLastNode = function(wrapper){
        return wrapper.find('[data-value]:visible:last');
    };

    var create = function(){
        createWrapper.call(this);
        //createOptionList.call(this);
        attachEvent.call(this);
    };

    var scrollToItem = function(){
        var wrapper = this.$optionWrapper.find('[data-wrapper="list"]');
        var wrapperTop = wrapper.offset().top;
        var heights = wrapper.height();
        var scroll = wrapper.scrollTop();
        var elem = wrapper.find('li.'+this.options.selectedClass);

        if (elem.length) {
            var elemH = elem.outerHeight();
            var tops = elem.offset().top + elemH;
                tops = tops - wrapperTop + scroll;

            if (tops > heights) {
                wrapper.scrollTop( tops - heights );
            } else if (scroll > tops) {
                wrapper.scrollTop( tops - heights );
            }
        }
    };

    var SelectMenu = function (elem, options) {
        this.type =  null;
        this.template =  null;
        this.options =  null;
        this.searchId = null;
        this.searchInputId = null;
        this.optionWrapperId =  null;
        this.elem =  null;
        this.$elem = null;
        this.elemId = null;
        this.overlayId = null;
        this.elemEventType = null;
        this.active = false;

        this.init('selectmenu', elem, options);
    };

    SelectMenu.OPTIONS =  {
        template: 'base-form-select-options-list',
        cssClasses: '',
        trigger: 'click',
        search: true,
        sorting: false,
        selectedClass: 'selected'
    };

    SelectMenu.prototype.init = function (type, elem, options) {
        this.type = type;
        this.elem = elem;
        this.$elem = $(elem);
        this.options  = this.getOptions(options);
        this.elemId = $(elem).attr('id');
        this.optionWrapperId = 'ez-select-'+this.elemId;
        this.searchId = 'ez-select-search-'+ this.elemId;
        this.searchInputId = 'ez-select-search-input-'+ this.elemId;
        this.overlayId = 'ez-select-overlay-'+ this.elemId;
        this.elemEventType = '.' + this.type + '.' + this.overlayId;
        this.template = $.ezdia.template.get(this.options.template);

        create.call(this);
    };

    SelectMenu.prototype.getDefaults = function () {
      return SelectMenu.OPTIONS;
    };

    SelectMenu.prototype.getOptions = function (options) {
        options = $.extend({}, this.getDefaults(), this.$elem.data(), options);

        return options;
    };

    SelectMenu.prototype.show = function(){

        if (this.elem.disabled) {
            return false;
        }

        createOptionList.call(this);

        var self = this;
        var pos = this.$elem.offset();
        var width = this.$elem.outerWidth();
        var height = this.$optionWrapper.outerHeight();

        this.$optionWrapper.css({
            top: pos.top,
            left: pos.left,
            height: height,
            width: width
        }).fadeIn('fast').on('click', '[data-options="options"]',function(){
            var elem = $(this);
            setValue.call(self, elem);
        });
        scrollToItem.call(self);
        this.active = true;

        if(this.options.search) {
            $('#'+ this.searchInputId).val('').focus();
        }

        $('body').on('click' + this.elemEventType, function(e){
            if(e.target.id == self.overlayId || e.target.id == self.searchInputId) {
                return false;
            }
            self.hideOptions();

        }).on('keydown' + this.elemEventType, function(e){
            e.stopPropagation();
            self.keyListener(e);
        });;

    };

    SelectMenu.prototype.keyListener = function (e) {
        var key = e.which;

        switch (key) {
            case 9:
                this.hideOptions();
                break;
            case 13:
                setValue.call(this);
                this.hideOptions();
                break;
            case 38:
            case 40:
                e.preventDefault();
                this.keyMovement(key);
                break;
            default:
                break;
        }

    };

    SelectMenu.prototype.keyMovement = function (key) {
        var wrapper = $('#' + this.searchId);
        var hasLis = wrapper.find('[data-value]:visible').length;

        if (!hasLis) {
            return;
        }

        $('#'+ this.searchInputId).blur();

        var selectedClass = this.options.selectedClass;
        var lis = wrapper.find('[data-value]');
        var selectedElem = wrapper.find('.'+ selectedClass) || wrapper.find(':hidden .'+ selectedClass);
        var selectedIndex = selectedElem.data('index');
        var nextItem  = null;

        if (key == 38) {
            if(!selectedIndex || selectedIndex == -1) {
                nextItem = getLastNode(wrapper);
            } else {
                nextItem = this.getNeighbors(wrapper, lis, selectedIndex, -1) ;
            }
        } else {
            if(selectedIndex == lis.length - 1 || selectedIndex == -1) {
                nextItem = getFirstNode(wrapper);
            } else {
                nextItem = this.getNeighbors(wrapper, lis, selectedIndex, 1) ;
            }
        }
        addSelected.call(this, nextItem);
        scrollToItem.call(this);
    };

    SelectMenu.prototype.getNeighbors = function (wrapper, lis, index, operator) {
        var elem = null;

        for (var i = index; ; ){
            if (operator == 1 && i > lis.length){
                break;
            } else if(i < 0) {
                break;
            }

            elem = lis.get(i + operator);
            elem = $(elem);

            if(elem.length && elem.is(':visible')) {
                break;
            } else {
                elem = null;
            }

            i = i + operator;
        }

        if(!elem) {
            if (operator == 1) {
                elem = getFirstNode(wrapper);
            } else {
                elem = getLastNode(wrapper);
            }
        }

        return elem;
    };

    SelectMenu.prototype.hideOptions = function () {
        this.$optionWrapper.fadeOut('fast');
        $('body').off(this.elemEventType);
        if(this.active){
            setValue.call(this);
        }
        this.$optionWrapper.remove();
    };

    SelectMenu.prototype.updateValue = function (value) {
        var wrapper = $('#' + this.searchId);
        var elem = wrapper.find('[data-value="' + value + '"]');
        this.$elem.val(value);

        if (elem.length) {
            addSelected.call(this, elem);
        } else {
            var classes = this.options.selectedClass;
            wrapper.find('.' + classes).removeClass(classes);
        }

    };

    SelectMenu.prototype.destroy = function () {
        this.$elem.removeData('ez.' + this.type);
        $('#'+this.overlayId).off('.' + this.type);
        this.$elem.off('.' + this.type);
        $('body').off(this.elemEventType);
    };

    SelectMenu.prototype.disabled = function () {
        //this.$overlayId.hide();
    };

    // PLUGIN DEFINITION
    // =========================

    var old = $.fn.selectmenu;

    var publicMethods = {
        updateValue : SelectMenu.prototype.updateValue,
        destroy : SelectMenu.prototype.destroy,
        disabled: SelectMenu.prototype.disabled
    };

    $.fn.selectmenu = function(option) {
        if (typeof option === 'string' && option !== 'destroy') {
            var args = Array.prototype.slice.call(arguments, 1);
            return invokePublicMethod.call(this, option, args);
        } else {
            return createNewSelectMenuInstance.call(this, option);
        }
    };

    function invokePublicMethod(methodName, args) {
        if(publicMethods[methodName]) {
            var inputObject = retrieveSelectMenuObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);

            if (typeof result === "undefined") {
                return $(this);
            } else {
                return result;
            }
        } else {
            throw new Error("method '" + methodName + "()' does not exist for select menu.");
        }
    }

    function retrieveSelectMenuObjectFromElement(element) {
        var inputObject = $(element).data('ez.selectmenu');
        if(inputObject && inputObject instanceof SelectMenu) {
            return inputObject;
        } else {

        }
    }

    function createNewSelectMenuInstance(option) {
        var $this = $(this);
        $this.each(function() {
            var self = $(this);
            var data    = self.data('ez.selectmenu');
            var options = typeof option == 'object' && option;

            if (!data) self.data('ez.selectmenu', (data = new SelectMenu(this, options)));
            if (typeof option == 'string') data[option]();
        });
        return $this;
    }

    $.fn.selectmenu.Constructor = SelectMenu;


    // TOOLTIP NO CONFLICT
    // ===================

    $.fn.selectmenu.noConflict = function () {
      $.fn.selectmenu = old;
      return this;
    };

})(jQuery, window, document);

